/**
 * Icon lookup for AI Studio tasks.
 *
 * Kept out of `aiStudioTasks.js` so that registry stays pure data (no React
 * imports), which is what lets it be unit tested and reused server-side later.
 * The registry carries an `icon` string key; this maps it to a component.
 */

import {
  MdOutlineTextFields,
  MdOutlineSubtitles,
  MdRecordVoiceOver,
  MdOutlineMovie,
  MdOutlineViewCarousel,
} from "react-icons/md";
import { HiSparkles } from "react-icons/hi2";

const TASK_ICONS = {
  metadata: MdOutlineTextFields,
  subtitles: MdOutlineSubtitles,
  dub: MdRecordVoiceOver,
  trailer: MdOutlineMovie,
  thumbnails: MdOutlineViewCarousel,
};

/** Returns the icon component for a task's `icon` key (sparkle as a fallback). */
export const taskIcon = (key) => TASK_ICONS[key] || HiSparkles;

export default TASK_ICONS;
